export const getPageLabel = (page) => {
  return page
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getPageSelectOptions = (pages) => {
  return pages.map((page) => ({
    label: getPageLabel(page),
    value: page,
  }));
};
